export class CurrencyUtils {
  static getCurrencySymbol(currencyCode: string): string {
    return currencyCode === 'EUR' ? '€' : currencyCode;
  }
}
